import { render } from "./AboutMe.vue?vue&type=template&id=7c213928&scoped=true"
const script = {}

import "./AboutMe.vue?vue&type=style&index=0&id=7c213928&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Marti\\Desktop\\Web Development\\portfolio-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c213928"]])

export default __exports__